import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function getDataGraphicVersoesSistemas(SISCODIGO, nivelVersao, filters) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }

    var body = {
        SISCODIGO: SISCODIGO, 
        nivelVersao: nivelVersao
    }

    var newbody = {...body, ...filters};
    
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/graficosdashversoes", newbody, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}
export function getDataGraficoDashVersaoEMS(SISCODIGO, aplicativo, filtros) {
    var self = this;
    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    
    var body = filtros ? filtros : false

    body = {...body, ...{SISCODIGO: SISCODIGO, aplicativo: aplicativo}};
    
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/graficodashversaoems", body, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}



